<nav mat-tab-nav-bar mat-stretch-tabs='false' mat-align-tabs='start' [tabPanel]='tabPanel'>
  <a mat-tab-link *ngFor='let link of linksPos index as i'
     [routerLink]='link.url'
     [routerLinkActive]='link.url'
     [active]='rla.isActive'
     [attr.data-cy]="'navigation-tab-link-'+link.key"
     [disabled]='link.isDisabled'
     #rla="routerLinkActive">
    <span
      class='button-s-semi-bold'
      [ngClass]="{
          'dsp-color-interaction-highlight': rla.isActive,
          'dsp-color-text-neutral': !rla.isActive,
        }"
    >
      {{ getLabelDisplay(link) }}
    </span>
  </a>
</nav>
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>

